









































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';

@Component({
    name: 'WorkerAvailabilityDetailsEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new WorkerDto();
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
    }
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  get availabilityOptions() {
    return ListUtils.availabilityTypes();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await WorkerDetailsModule.editAvailabilityDetails(this.entity);
    this.dialog = false;
  }
}
